import React, { Component } from "react";

import pageTitlesTR from "./tr/page_titles.json";
import pageTitlesEN from "./en/page_titles.json";

import authTR from "./tr/auth.json";
import authEN from "./en/auth.json";

import dashboardTR from "./tr/dashboard.json";
import dashboardEN from "./en/dashboard.json";

import projectTR from "./tr/project.json";
import projectEN from "./en/project.json";

import companyTR from "./tr/company.json";
import companyEN from "./en/company.json";

import headerTR from "./tr/header.json";
import headerEN from "./en/header.json";

import accountTR from "./tr/account.json";
import accountEN from "./en/account.json";

import projectSettingsTR from "./tr/project_settings.json";
import projectSettingsEN from "./en/project_settings.json";

import formFieldsTR from "./tr/form_fields.json";
import formFieldsEN from "./en/form_fields.json";

import formTemplatesTR from "./tr/form_templates.json";
import formTemplatesEN from "./en/form_templates.json";

import designApprovalProcessTR from "./tr/design_approval_process.json";
import designApprovalProcessEN from "./en/design_approval_process.json";

import userTR from "./tr/user.json";
import userEN from "./en/user.json";

import tasksTR from "./tr/tasks.json";
import tasksEN from "./en/tasks.json";

import formTR from "./tr/form.json";
import formEN from "./en/form.json";

import formBoxTR from "./tr/form_box.json";
import formBoxEN from "./en/form_box.json";

export default class LanguageFiles extends Component {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(pageTitlesTR, "tr");
    this.props.addTranslationForLanguage(pageTitlesEN, "en");

    this.props.addTranslationForLanguage(authTR, "tr");
    this.props.addTranslationForLanguage(authEN, "en");

    this.props.addTranslationForLanguage(dashboardTR, "tr");
    this.props.addTranslationForLanguage(dashboardEN, "en");

    this.props.addTranslationForLanguage(projectTR, "tr");
    this.props.addTranslationForLanguage(projectEN, "en");

    this.props.addTranslationForLanguage(companyTR, "tr");
    this.props.addTranslationForLanguage(companyEN, "en");

    this.props.addTranslationForLanguage(headerTR, "tr");
    this.props.addTranslationForLanguage(headerEN, "en");

    this.props.addTranslationForLanguage(accountTR, "tr");
    this.props.addTranslationForLanguage(accountEN, "en");

    this.props.addTranslationForLanguage(projectSettingsTR, "tr");
    this.props.addTranslationForLanguage(projectSettingsEN, "en");

    this.props.addTranslationForLanguage(formFieldsTR, "tr");
    this.props.addTranslationForLanguage(formFieldsEN, "en");

    this.props.addTranslationForLanguage(formTemplatesTR, "tr");
    this.props.addTranslationForLanguage(formTemplatesEN, "en");

    this.props.addTranslationForLanguage(designApprovalProcessTR, "tr");
    this.props.addTranslationForLanguage(designApprovalProcessEN, "en");

    this.props.addTranslationForLanguage(userTR, "tr");
    this.props.addTranslationForLanguage(userEN, "en");

    this.props.addTranslationForLanguage(tasksTR, "tr");
    this.props.addTranslationForLanguage(tasksEN, "en");

    this.props.addTranslationForLanguage(formTR, "tr");
    this.props.addTranslationForLanguage(formEN, "en");

    this.props.addTranslationForLanguage(formBoxTR, "tr");
    this.props.addTranslationForLanguage(formBoxEN, "en");
  }

  render() {
    return <></>;
  }
}
